/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { PencilIcon } from "@heroicons/react/24/outline";

// @store
import useAuthStore from "../../../store/useAuthStore";
import { useCompanyStore } from "../../../store/useCompanyStore";
import { useSpinnerStore } from "../../../store/useSpinnerStore";

// @services
import profileService from "../../../services/profile.service";

// @components
import DocumentsCompany from "./components/DocumentsCompany";
import FormCompanyInfo from "./components/FormCompanyInfo";

// @helpers
import { updateDataCompany } from "../../../helpers/functionsUtils";
import { IFormDataCompany } from "../../../types/professional.types";
import { UserRole } from "../../../types/auth.types";

export default function UserProfessionalPage() {
  const { user } = useAuthStore();
  const { data, getProfessional } = useCompanyStore();
  const { t } = useTranslation();
  const [logo, setLogo] = useState('');
  const { openSpinner } = useSpinnerStore();
  const [history, setHistory] = useState({ history: data?.history })

  const getLogoForCompany = async (id?: string) => {
    const logoId = id ? id : data?.companyLogoId;
    if (!logoId) return;
    openSpinner(true);
    try {
      await profileService.getLogoForCompany(logoId).then((response: any) => {
        openSpinner(false);
        return setLogo(response);
      })
    } catch (error) {
      openSpinner(false);
      setLogo("");
      toast.error(t("error.callList"));
    }
  }

  useEffect(() => {
    getLogoForCompany();
  }, [])

  const handleHistory = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setHistory({ history: e.target.value });
  }

  const updateData = async (field: keyof IFormDataCompany) => {
    const params = {
      field: field,
      formValue: history,
      openSpinner,
      t,
      getProfessional,
      userType: UserRole.PROFESSIONAL,
      userId: data?.professionalId ?? ''
    };
    return updateDataCompany(params);
  }

  const uploadLogo = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append('file', file);
    formData.append('documentTypes', "0");
    updateLogo(formData);
  }

  const updateLogo = async (formData: FormData) => {
    openSpinner(true);
    try {
      await profileService.updateLogoForCompany(formData);
      getProfessionalForLogo();
    } catch (error) {
      openSpinner(false);
      toast.error(t("error.callList"));
    }
  }

  const getProfessionalForLogo = async () => {
    try {
      const response = await getProfessional();
      getLogoForCompany(response?.companyLogoId);
    } catch (error) {
      openSpinner(false);
      toast.error(t("error.callList"));
    }
  }

  return (
    <div className="min-h[30vh] h-[100vh] overflow-y-auto px-0 lg:px-6">
      <div className="grid grid-cols-1 lg:grid-cols-[1fr,1fr] 2xl:grid-cols-[1fr,1fr,1fr] gap-[20px]">

        <div className="w-full flex flex-col flex-1 items-center text-center p-6 bg-white dark:bg-dark-cBackground rounded-lg shadow-md">
          <img
            src={logo ? logo : '/assets/img/no-image.png'}
            alt="Company logo"
            className="size-40 rounded-full object-cover"
          />
          <div className="bg-[#83B2A3] rounded-[100%] p-2 mt-[-35px] mr-[-100px] ">
            <label htmlFor="upload-logo-company" className="w-full">
              <PencilIcon className="w-[15px] text-white" />
              <input
                id="upload-logo-company"
                type="file"
                accept="image/*"
                onChange={(e) => uploadLogo(e)}
                className="hidden"
              />
            </label>
          </div>
          <h2 className="mt-4 mb-2 text-xl text-[#444A6D] dark:text-dark-cText font-medium">
            {data?.name ?? user?.name}
          </h2>
          <p className="text-gray-500 dark:text-dark-cText/60">{data?.category.name}</p>

          <div className="mt-5 flex items-center w-full justify-between">
            <h3 className="text-left font-semibold dark:text-dark-cText">
              {`${t("professional.profile.historyTitle")} ${data?.name}`}
            </h3>
            <button
              className="px-4 py-2 text-sm text-[#F97068] bg-trasparent rounded-lg"
              onClick={() => updateData('history')}
            >
              {t("professional.profile.buttonEdit")}
            </button>
          </div>

          <div className="flex w-full flex-1 min-h-[30vh] max-h-[60vh] overflow-auto">
            <textarea
              id="historyCompany"
              value={history.history}
              onChange={(e) => handleHistory(e)}
              className="w-full flex h-full px-4 py-2 border dark:border-white/60 rounded-lg text-sm text-justify dark:bg-dark-cBackground text-[#A1A1A1] dark:text-dark-cText/60 "
            />
          </div>
        </div>

        <FormCompanyInfo />

        <DocumentsCompany />
      </div>
    </div>
  );
}
